import { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import css from './listbox.scss'

export const ListBox = ({ name, options, onSelect, inFocus, onBlur }) => {
  const listRef = useRef()
  const [activeIndex, setActiveIndex] = useState(-1)

  const handleKeyDown = (event) => {
    event.preventDefault()
    const { key } = event
    switch (key) {
      case 'ArrowUp':
        if (activeIndex > 0) {
          setActiveIndex(activeIndex - 1)
        } else {
          onBlur()
        }
        break
      case 'ArrowDown':
        if (activeIndex < options.length - 1) {
          setActiveIndex(activeIndex + 1)
        }
        break
      case 'Enter':
        onSelect(options[activeIndex]?.value)
        break
      default:
        break
    }
  }

  useEffect(() => {
    if (inFocus && activeIndex === -1) {
      listRef.current.focus()
      setActiveIndex(0)
    }

    if (!inFocus && activeIndex !== -1) {
      listRef.current.blur()
      setActiveIndex(-1)
    }
  }, [inFocus, activeIndex])

  return (
    <ul
      tabIndex="0"
      ref={listRef}
      role="listbox"
      aria-label={name}
      className="list-unstyled"
      onKeyDown={handleKeyDown}
      style={{ outline: 'none' }}
      aria-activedescendant={options[activeIndex]?.value}
    >
      {options.map((option, idx) => (
        <li
          role="option"
          id={option.value}
          key={option.value}
          aria-selected={idx === activeIndex}
          className={classnames({ [css.active]: idx === activeIndex })}
        >
          {option.element}
        </li>
      ))}
    </ul>
  )
}

ListBox.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.node.isRequired,
      element: PropTypes.node.isRequired,
    })
  ).isRequired,
  onBlur: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  inFocus: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
}
